/**
 * Resolve cable length (feet) for diagrams and product images.
 * SKU is authoritative at checkout when it disagrees with config.length
 * (e.g. image captured before the length step).
 */

function stripSkuTimestamp(sku) {
  return String(sku || '')
    .trim()
    .replace(/_+\d{8}_+\d{6,}$/, '')
    .replace(/--\d{8}-\d{6,}$/, '')
    .trim();
}

function parseLengthFeetFromSku(sku) {
  const base = stripSkuTimestamp(sku);
  if (!base) return null;
  const lastSegment = base.split('-').pop();
  const n = parseFloat(lastSegment);
  return Number.isFinite(n) ? n : null;
}

function resolveLengthFeetForImage(config = {}) {
  const fromSku = parseLengthFeetFromSku(config.sku);
  const raw = config.length;
  const fromConfig =
    raw != null && raw !== '' && !Number.isNaN(Number(raw)) ? Number(raw) : null;

  if (fromSku != null) return fromSku;
  if (fromConfig != null) return fromConfig;
  return 10;
}

function isStandardEndToEndStyle(style) {
  return (
    style === undefined ||
    style === null ||
    style === '' ||
    style === 'end-to-end' ||
    style === 'standard' ||
    style === '1:1'
  );
}

/** True for TYPE-endA-endB-length SKUs (not PSH/PSZ hybrid, zip, or wye). */
function isOneToOneSku(sku) {
  const base = stripSkuTimestamp(sku);
  if (!base || /^PANEL/i.test(base)) return false;
  const parts = base.split('-');
  if (parts.length !== 4) return false;
  const typeCode = parts[0];
  if (typeCode === 'PSH' || typeCode === 'PSZ') return false;
  const length = parseFloat(parts[parts.length - 1]);
  if (!Number.isFinite(length)) return false;
  if (!parts[1] || !parts[2]) return false;
  return true;
}

/** Parse a 1:1 SKU into wire type, connector codes, and length (feet). */
function parseOneToOneSku(sku) {
  if (!isOneToOneSku(sku)) return null;
  const base = stripSkuTimestamp(sku);
  const [wireType, endACode, endBCode, lengthStr] = base.split('-');
  return {
    wireType,
    endACode,
    endBCode,
    lengthFeet: parseFloat(lengthStr),
    baseSku: base
  };
}

module.exports = {
  stripSkuTimestamp,
  parseLengthFeetFromSku,
  resolveLengthFeetForImage,
  isStandardEndToEndStyle,
  isOneToOneSku,
  parseOneToOneSku
};
